import catalog from "../../../api/lib/job-quests.json";
import type { JobQuest, QuestRank, QuestStatus } from "./types";

// 掲載内容の唯一の編集元。PHPも同じJSONを読み、DBへの取り込みは不要です。
// 公開情報のみ置いてください。下書き・社内情報・応募者情報は含めません。
const quests: JobQuest[] = catalog
  .filter((q) => q.published)
  .map((q) => ({
    ...q,
    id: q.questNumber,
    rank: q.rank as QuestRank,
    status: q.status as QuestStatus,
    contactUrl: `/contact/?type=job-quest&quest=${q.questNumber}#contact`,
  }));

// 表示内容は本番と共通。ローカルでは誤送信を防ぐため応募のみプレビューにします。
export const isLocalQuestPreview = () =>
  ["localhost", "127.0.0.1", "[::1]"].includes(window.location.hostname) &&
  new URLSearchParams(window.location.search).get("live") !== "1";

export function useQuests(number?: number) {
  const selected =
    number === undefined
      ? quests
      : quests.filter((q) => q.questNumber === number);
  return {
    status: number !== undefined && selected.length === 0 ? "missing" : "ready",
    quests: selected,
    message: "",
    retry: () => window.location.reload(),
  };
}
